import { createAction } from '@wix/communities-blog-client-common';

export const SET_READING_SESSION_ID = 'SET_READING_SESSION_ID';
export const setReadingSessionId = createAction(SET_READING_SESSION_ID);
